import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthComponent } from './auth/auth.component';
import { HeaderComponent } from './header/header.component';
import { FeaturesComponent } from './features/features.component';
import { AuthService } from './auth/auth.service';
import { HttpClientModule } from '@angular/common/http';
import { LoadingSpinnerComponent } from './shared/loading-spinner/loading-spinner.component';
import { PatentListComponent } from './patent-list/patent-list.component';

import { LogOutComponent } from './log-out/log-out.component';
import { MasterDataComponent } from './master-data/master-data.component';

import { Ng2SearchPipeModule } from 'ng2-search-filter';

//import { PatentDetailComponent } from './patent-detail/patent-detail.component';
import { InventorRecordingComponent } from './master-data/inventor-recording/inventor-recording.component';
import { CompanyRecordingComponent } from './master-data/company-recording/company-recording.component';
import { NavBarComponent } from './patent-detail/nav-bar/nav-bar.component';
import { RecordInventionComponent } from './patent-detail/record-invention/record-invention.component';
import { DayAgoPipe } from './shared/day-ago.pipe';
import {AngularFireStorageModule} from '@angular/fire/storage';
import {AngularFireModule} from '@angular/fire';
import { MailCenterComponent } from './mail-center/mail-center.component';
import { WELLCOMEComponent } from './wellcome/wellcome.component';
import { PatentRecordComponent } from './patent-detail/patent-record/patent-record.component';
import { CountryRecordComponent } from './patent-detail/patent-record/country-record/country-record.component'
import {NgxPrintModule} from 'ngx-print';
import { CriticalComponent } from './patent-list/critical/critical.component';
import { BbfComponent } from './bbf/bbf.component';
import { AttorneyRecordingComponent } from './master-data/attorney-recording/attorney-recording.component';
import { OtherJobsComponent } from './master-data/other-jobs/other-jobs.component';
import { EditCountryComponent } from './patent-detail/patent-record/country-record/edit-country/edit-country.component';
import { SearchComboComponent } from './patent-list/search-combo/search-combo.component';
import { RdprojectRecordingComponent } from './master-data/rdproject-recording/rdproject-recording.component';


@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    HeaderComponent,
    FeaturesComponent,
    LoadingSpinnerComponent,
    PatentListComponent,

    LogOutComponent,
    MasterDataComponent,

    InventorRecordingComponent,
    CompanyRecordingComponent,
    NavBarComponent,
    RecordInventionComponent,
    DayAgoPipe,
    MailCenterComponent,
    WELLCOMEComponent,
    PatentRecordComponent,
    CountryRecordComponent,
    CriticalComponent,
    BbfComponent,
    AttorneyRecordingComponent,
    OtherJobsComponent,
    EditCountryComponent,
    SearchComboComponent,
    RdprojectRecordingComponent,



  ],
  imports: [
    BrowserModule,
    AppRoutingModule,FormsModule,ReactiveFormsModule,HttpClientModule, Ng2SearchPipeModule,NgxPrintModule,
    AngularFireModule.initializeApp({
    apiKey: "AIzaSyBcdty610Kp9vHBpTFQkhVip9-t0Kcc7ec",
    authDomain: "patent-book.firebaseapp.com",
    databaseURL: "https://patent-book-default-rtdb.firebaseio.com",
    projectId: "patent-book",
    storageBucket: "patent-book.appspot.com",
    messagingSenderId: "775317340553",
    appId: "1:775317340553:web:a2093d0c555da5f0852158",
    measurementId: "G-1DS7R01NJV"

    }),
  ],
  providers: [AuthService,PatentListComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
/*apiKey: "AIzaSyDiMpNijuptReemjKovadIOx_bQN2pdDsI",
      authDomain: "sisecam-a8421.firebaseapp.com",
      databaseURL: "https://sisecam-a8421-default-rtdb.firebaseio.com",
      projectId: "sisecam-a8421",
      storageBucket: "sisecam-a8421.appspot.com",
      messagingSenderId: "796200672729",
      appId: "1:796200672729:web:52b7d0b7e05f4afc110dc8",
      measurementId: "G-92LBMP4XSQ"*/   //Old Directory
